export default __webpack_public_path__ + "static/media/cristiano_ronaldo.5b6c95a6.png";